var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "86px",
    viewBox: "0 0 100 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mess") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100.001258%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cortes",
    transform: "translate(-673.000000, -483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(261.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messenger",
    transform: "translate(423.000000, 163.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5418888,0.0392258903 C16.8281486,0.0392258903 0,16.1296861 0,37.8608293 C0,49.2284923 4.60641488,59.0506552 12.1054102,65.8367343 C12.7335576,66.4094323 13.1135481,67.2017952 13.1445677,68.0569196 L13.3539502,74.992057 C13.4237444,77.2043973 15.6804224,78.6400648 17.6811884,77.7535597 L25.3275269,74.3409073 C25.9789391,74.0506357 26.7001455,73.9957194 27.3825774,74.1840037 C30.8955503,75.164651 34.6411705,75.6824327 38.5418888,75.6824327 C60.255629,75.6824327 77.0837776,59.5919725 77.0837776,37.8608293 C77.0837776,16.1296861 60.255629,0.0392258903 38.5418888,0.0392258903 Z",
    id: "Bubble_Solid_3_",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4012457,48.9225304 L26.7234102,30.753098 C28.5225487,27.8660725 32.3844925,27.1443161 35.0832002,29.1919075 L44.0866475,36.0250576 C44.9164225,36.6526719 46.048639,36.6448267 46.8706592,36.0172125 L59.0303537,26.6814506 C60.6511293,25.4340673 62.7759738,27.403207 61.6825319,29.1448365 L50.3681223,47.3064237 C48.5689838,50.1934492 44.7070401,50.9152056 42.0083323,48.8676141 L33.0048851,42.034464 C32.17511,41.4068498 31.0428936,41.414695 30.2208734,42.0423092 L18.053424,51.3859163 C16.4326484,52.6332996 14.3078038,50.6641599 15.4012457,48.9225304 Z",
    id: "Bolt_4_",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.a16a741a8f9a73315e29184ba9a8d117.svg";
export { ForwardRef as ReactComponent };